var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { values, mapValues } from 'lodash';
/**
* Add global font "palette" to the global theme object.
* Remove useless version property from theme object.
*/
export default function themeMigrations(theme) {
    var updatedTheme = __assign({}, theme); // Ensure the global theme doesnt already have a fontPalette object set up.
    if (!updatedTheme.global.hasOwnProperty('fontPalette')) {
        // Determine the primary and secondary fonts in the existing global theme by counting the usage numbers.
        var fontFamilyCounts_1 = {};
        var primaryCount_1 = 0;
        var secondaryCount_1 = 0;
        var primaryFontFamily_1;
        var secondaryFontFamily_1;
        values(updatedTheme.global.elements).forEach(function (element) {
            var fontFamily = element.text.fontFamily;
            if (!fontFamilyCounts_1.hasOwnProperty(fontFamily)) {
                fontFamilyCounts_1[fontFamily] = 1;
            }
            else {
                fontFamilyCounts_1[fontFamily] += 1;
            }
            if (fontFamilyCounts_1[fontFamily] > primaryCount_1) {
                if (primaryFontFamily_1 !== fontFamily) {
                    secondaryCount_1 = primaryCount_1;
                    secondaryFontFamily_1 = primaryFontFamily_1;
                    primaryFontFamily_1 = fontFamily;
                }
                primaryCount_1 = fontFamilyCounts_1[fontFamily];
            }
            else if (fontFamilyCounts_1[fontFamily] > secondaryCount_1) {
                secondaryCount_1 = fontFamilyCounts_1[fontFamily];
                secondaryFontFamily_1 = fontFamily;
            }
        });
        var fontPalette_1 = {
            primary: primaryFontFamily_1,
            secondary: secondaryFontFamily_1 || primaryFontFamily_1
        }; // Modify the font families in the global theme elements as necessary.
        var elements = mapValues(updatedTheme.global.elements, function (element) {
            var fontFamily = element.text.fontFamily;
            if (fontFamily === fontPalette_1.primary) {
                fontFamily = 'primary';
            }
            else if (fontFamily === fontPalette_1.secondary) {
                fontFamily = 'secondary';
            }
            return __assign(__assign({}, element), { text: __assign(__assign({}, element.text), { fontFamily: fontFamily }) });
        }); // Apply new fonts and elements info to the global theme.
        updatedTheme.global = __assign(__assign({}, updatedTheme.global), { fontPalette: fontPalette_1, elements: elements });
    } // The version property is useless, so remove it.
    if (updatedTheme.hasOwnProperty('version')) {
        delete updatedTheme.version;
    }
    return updatedTheme;
}
